// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "audio,video{outline:none !important}", "",{"version":3,"sources":["webpack://./client/modules/file-viewer/styles.scss"],"names":[],"mappings":"AACA,YAEE,uBAAA","sourcesContent":["@import \"~@/styles/index.scss\";\naudio,\nvideo {\n  outline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
